import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from "../components-new/Tooltip";

const ShowChatIcon = ({text = 'chatHistory', fill = '#043e5c', style, ...rest}) => {
    return (
        <Tooltip text={text}>
            <svg
                {...rest}
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 23.54 23.58"
                style={{enableBackground: 'new 0 0 23.54 23.58', ...style}}
                xmlSpace="preserve"
                fill={fill}
            >
                <g id="Group_421" transform="translate(711.246 -194.876)">
                    <path
                        id="Path_2983"
                        d="M-703.72,208.05c0.75,0,1.35-0.61,1.35-1.35c0-0.75-0.61-1.35-1.35-1.35
c-0.75,0-1.35,0.61-1.35,1.35C-705.07,207.44-704.46,208.05-703.72,208.05z"
                    />
                    <path
                        id="Path_2984"
                        d="M-699.43,208.05L-699.43,208.05c0.75,0,1.35-0.61,1.35-1.35c0-0.75-0.61-1.35-1.35-1.35l0,0
c-0.75,0-1.35,0.61-1.35,1.35C-700.79,207.44-700.18,208.05-699.43,208.05z"
                    />
                    <path
                        id="Path_2985"
                        d="M-695.15,208.05L-695.15,208.05c0.36,0,0.7-0.14,0.96-0.4c0.26-0.25,0.4-0.6,0.4-0.96
c0-0.75-0.61-1.35-1.35-1.35l0,0c-0.75,0-1.36,0.61-1.36,1.36c0,0,0,0,0,0.01C-696.5,207.45-695.9,208.05-695.15,208.05z"
                    />
                    <path
                        id="Path_2986"
                        d="M-690.51,199.02h0.06l-0.69-0.69c-2.2-2.2-5.19-3.45-8.3-3.46c-0.02,0-0.04,0-0.05,0
c-3.12,0.01-6.11,1.25-8.31,3.46c-4.23,4.26-4.6,11.02-0.85,15.71c-0.36,0.74-0.93,1.35-1.64,1.75c-0.66,0.33-0.94,1.12-0.63,1.79
l0.01,0.03c0.2,0.4,0.57,0.67,1.01,0.74c0.31,0.05,0.63,0.07,0.95,0.07c1.46,0,2.88-0.45,4.07-1.29c1.67,0.87,3.52,1.32,5.39,1.32
c4.34,0.01,8.34-2.37,10.41-6.19C-686.81,207.98-687.38,202.73-690.51,199.02z M-706.74,214.32c0.08-0.18,0.1-0.37,0.06-0.56
c-0.02-0.19-0.1-0.38-0.23-0.52c-3.62-4.11-3.23-10.36,0.87-13.99c4.11-3.62,10.36-3.23,13.99,0.87c3.42,3.9,3.27,9.78-0.36,13.5
l-0.07,0.05c-3.19,3.19-8.13,3.83-12.03,1.54c-0.15-0.09-0.31-0.13-0.48-0.13h-0.01c-0.23,0-0.46,0.09-0.62,0.25l-0.06,0.04
c-0.72,0.58-1.58,0.96-2.49,1.11C-707.55,215.86-707.07,215.13-706.74,214.32L-706.74,214.32z"
                    />
                </g>
            </svg>
        </Tooltip>

    );
}

ShowChatIcon.propTypes = {
    fill: PropTypes.string,
    style: PropTypes.object,
    rest: PropTypes.object,
};

ShowChatIcon.defaultProps = {
    fill: '#043e5c',
    style: {},
    rest: {},
};

export default ShowChatIcon;



// WEBPACK FOOTER //
// ./src/assets/ShowChatIcon.jsx